module.exports = __webpack_public_path__ + "img/logo-group.5115951f.png";